// @ts-nocheck
import {
    getBoxCountCollection,
    getHeadDiameterCollection,
    getDriveTypeCollection,
    getFastenersTableDataView,
    getFinishCollection,
    getHeadCollection,
    getLengthCollection,
    getPointCollection,
    getThreadCollection,
} from "@store/Framework/Store/Store/Data/Fasteners/FastenersSelectors";
import convertSelectorToHook from "@toolkit/Framework/Common/Utilities/convertSelectorToHook";

export const useFastenersTableDataView = convertSelectorToHook(getFastenersTableDataView);
export const useLengthCollection = convertSelectorToHook(getLengthCollection);
export const useBoxCountCollection = convertSelectorToHook(getBoxCountCollection);
export const useHeadDiameterCollection = convertSelectorToHook(getHeadDiameterCollection);
export const useThreadCollection = convertSelectorToHook(getThreadCollection);
export const useDriveTypeCollection = convertSelectorToHook(getDriveTypeCollection);
export const usePointCollection = convertSelectorToHook(getPointCollection);
export const useHeadCollection = convertSelectorToHook(getHeadCollection);
export const useFinishCollection = convertSelectorToHook(getFinishCollection);
